@if (showLoader() || isRefDataLoading) {
  <section class="loaderwrp">
    <div class="scale-loader">
      <div class="dot-pulse"></div>
    </div>
  </section>
}

@if (!isRefDataLoading) {
  <div class="px24-700">
    <p class="mt44 mb24 academic-header font-bold">{{pageHeaderText}}</p>
    <form [formGroup]="academicDetailsForm">
      @for (ppQuestion of questions; track ppQuestion) {
        <ng-container class="mb44 mb28-700">
          @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'studyCountryName') {
            <div class="ques-wrap dropdown-field select-p-unset mb8"
              >
              <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
                <span class="optional-text"> {{optionalText}}</span>
              }</label>
              <mat-form-field
                [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes relative input-error':'slct-boxes relative'">
                <mat-select formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}" #select aria-label="{{ppQuestion.label}}">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="searchFilters[ppQuestion.mappingField]"
                      noEntriesFoundLabel="No results found">
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (optionValue of filteredOptions[ppQuestion.mappingField] | async; track optionValue) {
                    <mat-option [value]="optionValue.option_label" (click)="onInputChange(ppQuestion.mappingField, optionValue, $event)" id="{{optionValue.option_value}}">
                      {{optionValue.option_label}}
                    </mat-option>
                  }
                </mat-select>
                @if (academicDetailsForm.get(ppQuestion.mappingField)?.value) {
                  <button
                    (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear selection"
                    type="button" class="select-clear-icon right-52">
                    <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                  </button>
                }
              </mat-form-field>
              @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                <div class="reg-err"
                  >
                  {{ppQuestion.helpText}}
                </div>
              }
            </div>
          }
          <!-- qualification type, qualification title -->
          <!-- <ng-container
          *ngIf="ppQuestion.mappingField === 'qualificationType' || ppQuestion.mappingField === 'qualificationTitle'">
          <div
            [ngClass]="{'qual-type-field' : ppQuestion.mappingField === 'qualificationType' , 'qual-title-field': ppQuestion.mappingField === 'qualificationTitle'}"
            class="ques-wrap dropdown-field mb8"> -->
            @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'qualificationType' && showQualificationType()) {
              <div class="reg-wrap flex flex-column flex-1 mb8 trigger-width">
                <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
                  <span class="optional-text"> {{optionalText}}</span>
                }</label>
                <mat-form-field
                  [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes relative clear-icon input-error':'slct-boxes relative clear-icon'">
                  <mat-select formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}"
                    aria-label="{{ppQuestion.label}}">
                    <mat-option>
                      <ngx-mat-select-search
                        [formControl]="searchFilters[ppQuestion.mappingField]"
                        noEntriesFoundLabel="No results found">
                      </ngx-mat-select-search>
                    </mat-option>
                    @for (optionValue of filteredOptions[ppQuestion.mappingField] | async; track optionValue) {
                      <mat-option [value]="optionValue.option_label"
                        (click)="onInputChange(ppQuestion.mappingField, optionValue, $event)" id="{{optionValue.option_value}}">
                        {{optionValue.option_label}}
                      </mat-option>
                    }
                  </mat-select>
                  @if (academicDetailsForm.get(ppQuestion.mappingField)?.value) {
                    <button
                      (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear selection"
                      type="button" class="select-clear-icon right-52">
                      <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                    </button>
                  }
                </mat-form-field>
                @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                  <div class="reg-err"
                    >
                    {{ppQuestion.helpText}}
                  </div>
                }
              </div>
            }
            @if (ppQuestion.displayFormat.value === 'TEXT_BOX' && ppQuestion.mappingField === 'qualificationTitle') {
              <div class="reg-wrap flex flex-column flex-1 mb8"
                >
                <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
                  <span class="optional-text"> {{optionalText}}</span>
                }</label>
                <mat-form-field class="focus-none">
                  <input
                    [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'input-error':''"
                    matInput id="fieldOfStudy" aria-label="field of study" formControlName="{{ppQuestion.mappingField}}"
                    (blur)="onInputString(ppQuestion.mappingField, $event)" (keydown.enter)="preventEnter($event)">
                </mat-form-field>
                @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
                  <div class="reg-err"
                    >
                    {{ppQuestion.helpText}}
                  </div>
                }
              </div>
            }
          <!-- </div>
        </ng-container> -->
        <!-- ins names -->
        @if ((ppQuestion.mappingField === 'institutionName' && ppQuestion.displayFormat.value === 'SELECT_BOX') && showInstitution() && !isUgQualification) {
          <div class="ques-wrap dropdown-field select-p-unset mb8"
            >
            <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
              <span class="optional-text"> {{optionalText}}</span>
            }</label>
            <mat-form-field
              [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes input-error relative':'relative slct-boxes'">
              <mat-select id="{{ppQuestion.mappingField}}" formControlName="{{ppQuestion.mappingField}}" aria-label="{{ppQuestion.label}}">
                <mat-option>
                  <ngx-mat-select-search [formControl]="searchFilters[ppQuestion.mappingField]" noEntriesFoundLabel="No results found">
                  </ngx-mat-select-search>
                </mat-option>
                @for (optionValue of filteredOptions[ppQuestion.mappingField] | async; track optionValue) {
                  <mat-option [value]="optionValue.option_label" (click)="onInputChange(ppQuestion.mappingField, optionValue, $event)" id="{{optionValue.option_value}}">
                    {{optionValue.option_label}}
                  </mat-option>
                }
              </mat-select>
              @if (academicDetailsForm.get(ppQuestion.mappingField)?.value) {
                <button type="button" aria-label="Clear selection" (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" class="select-clear-icon right-52">
                  <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                </button>
              }
            </mat-form-field>
            @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
              <div class="reg-err"
                >
                {{ppQuestion.helpText}}
              </div>
            }
          </div>
        }
        <!-- Other institution name -->
        @if ((ppQuestion.mappingField === 'institutionName' && ppQuestion.displayFormat.value === 'TEXT_BOX') && showOtherInstitution() && !isUgQualification) {
          <div class="reg-wrap mb8"
            >
            <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
              <span class="optional-text"> {{optionalText}}</span>
            }</label>
            <!-- <p class="mb4">{{ppQuestion.defaultValue}}</p> -->
            <mat-form-field>
              <input
                [ngClass]="academicDetailsForm.get('other_institutionName')?.hasError('required') && submitted?'input-error w100':'w100'"
                matInput id="" aria-label="institution name" formControlName="other_institutionName"
                (blur)="onInputString('other_institutionName', $event)" (keydown.enter)="preventEnter($event)">
            </mat-form-field>
            @if (academicDetailsForm.get('other_institutionName')?.hasError('required') && submitted) {
              <div class="reg-err"
                >
                {{ppQuestion.helpText}}
              </div>
            }
          </div>
        }
        <!-- exam board name -->
        @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'examBoardName' && showExamBoard()) {
          <div class="reg-wrap mb8">
            <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
              <span class="optional-text"> {{optionalText}}</span>
            }</label>
            <mat-form-field
              [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes relative input-error':'slct-boxes relative'">
              <mat-select aria-label="{{ppQuestion.label}}" formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}">
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="searchFilters[ppQuestion.mappingField]"
                    noEntriesFoundLabel="No results found">
                  </ngx-mat-select-search>
                </mat-option>
                @for (optionValue of filteredOptions[ppQuestion.mappingField] | async; track optionValue) {
                  <mat-option [value]="optionValue.option_label"
                    id="{{optionValue.option_value}}" (click)="onInputChange(ppQuestion.mappingField, optionValue, $event)">
                    {{optionValue.option_label}}
                  </mat-option>
                }
              </mat-select>
              @if (academicDetailsForm.get(ppQuestion.mappingField)?.value) {
                <button
                  (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear selection"
                  type="button" class="select-clear-icon right-52">
                  <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                </button>
              }
            </mat-form-field>
            @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
              <div class="reg-err">
                {{ppQuestion.helpText}}
              </div>
            }
          </div>
        }
        <!-- major subjects / course name -->
        @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'majorSubjects' && showMajorSubjects() && !isUgQualification) {
          <div class="ques-wrap dropdown-field select-p-unset mb8"
            >
            <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
              <span class="optional-text"> {{optionalText}}</span>
            }</label>
            <!-- <p class="mb4">{{ppQuestion.defaultValue}}</p> -->
            <mat-form-field
              [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes relative input-error':'slct-boxes relative'">
              <mat-select formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}" #select aria-label="{{ppQuestion.label}}">
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="searchFilters[ppQuestion.mappingField]"
                    noEntriesFoundLabel="No results found">
                  </ngx-mat-select-search>
                </mat-option>
                @for (optionValue of filteredOptions[ppQuestion.mappingField] | async; track optionValue) {
                  <mat-option id="{{optionValue.option_value}}"
                    (click)="onInputChange(ppQuestion.mappingField, optionValue, $event)" [value]="optionValue.option_label">
                    {{optionValue.option_label}}
                  </mat-option>
                }
              </mat-select>
              @if (academicDetailsForm.get(ppQuestion.mappingField)?.value) {
                <button
                  (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear selection"
                  type="button" class="select-clear-icon right-52">
                  <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                </button>
              }
            </mat-form-field>
            @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
              <div class="reg-err"
                >
                {{ppQuestion.helpText}}
              </div>
            }
          </div>
        }
      </ng-container>
    }
    <!-- <p class="mt44 mb24 step-label font-bold">Study Mode</p> -->
    <!-- study mode, study status -->
    @for (ppQuestion of questions; track ppQuestion) {
      @if ((ppQuestion.mappingField === 'studyMode' || ppQuestion.mappingField === 'studyStatus') && ppQuestion.displayFormat.value === 'SELECT_BOX') {
        <div class="ques-wrap mb8">
          <label class="mt44 mt28-700 mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
            <span class="optional-text"> {{optionalText}}</span>
          }</label>
          <mat-chip-listbox id="{{ppQuestion.mappingField}}" class="tag-list" formControlName="{{ppQuestion.mappingField}}" [attr.aria-label]="ppQuestion.label">
            @for (optionValue of ppQuestion.options; track optionValue) {
              <mat-chip-option tabindex="0" [aria-label]="ppQuestion.options.option_label" class="tag"
                id="{{optionValue.option_value}}"
                [value]="optionValue.option_label"
                (selectionChange)="onInputChange(ppQuestion.mappingField, optionValue, $event)">
                {{optionValue.option_label}}
              </mat-chip-option>
            }
          </mat-chip-listbox>
          @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
            <div class="reg-err">
              {{ppQuestion.helpText}}
            </div>
          }
        </div>
      }
      <!-- Commencement, completion date pickers -->
      <!-- <ng-container *ngIf="ppQuestion.displayFormat.value === 'DATE_PICKER' && ppQuestion.mappingField === 'studyStartDate' || ppQuestion.mappingField === 'studyEndDate'">
      <div
        [ngClass]="{'qual-type-field' : ppQuestion.mappingField === 'studyStartDate' , 'qual-title-field': ppQuestion.mappingField === 'studyEndDate'}"
        class="ques-wrap dropdown-field mb8"> -->
        @if (ppQuestion.displayFormat.value === 'DATE_PICKER' && ppQuestion.mappingField === 'studyStartDate') {
          <div class="reg-wrap flex flex-column flex-1 mb8 padding-fix relative"
            >
            <div class="relative">
              <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">
                {{ ppQuestion.label }}@if (ppQuestion.mandatory === false) {
                <span class="optional-text"> {{optionalText}}</span>
              } </label>
              <span class="tooltip inline-flex" [class.active]="showStartDateTooltip">
                <span class="cursor-pointer" (click)="toggleTooltip($event, 'startDate')">
                  <img src="./assets/icons/info-icon.svg" alt="info icon" width="20" height="20" />
                </span>
                <div class="tooltip-box absolute">
                  <span class="tooltip-close" (click)="closeTooltip($event, 'startDate')"><img src="./assets/icons/tooltip-close.svg" alt="close" width="20" height="20" /></span>
                  <p>
                    {{infoTooltipText}}
                  </p>
                  <div class="tooltip-arrow absolute"></div>
                </div>
              </span>
            </div>
            <mat-form-field [ngClass]="{'date-error':((invalidStartDate || futureStartDate || startDateAfterEndDate || (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required'))) && submitted)}" appearance="fill" class="custom-date-wrapper focus-none">
              <input formControlName="{{ppQuestion.mappingField}}" [max]="todayDate" (dateChange)="onDateChange($event, 'studyStartDate')" (keydown.enter)="preventEnter($event)" matInput
                [matDatepicker]="picker" class="date-picker-input" aria-label="Commencement date" [placeholder]="ppQuestion.defaultValue || datePlaceholderText" />
              <span matSuffix class="date-suffix-icons">
                @if (academicDetailsForm.get(ppQuestion.mappingField)?.value) {
                  <button
                    (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear date"
                    type="button" class="date-clear-icon">
                    <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                  </button>
                }
                <mat-datepicker-toggle [for]="picker" class="custom-date"></mat-datepicker-toggle>
              </span>
              <mat-datepicker #picker panelClass="custom-datepicker">
                <mat-datepicker-actions>
                  <button mat-button matDatepickerCancel class="calendar-btn secondary-btn">{{cancelText}}</button>
                  <button mat-raised-button color="primary" matDatepickerApply
                  class="calendar-btn primary-btn">{{applyText}}</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
            @if (invalidStartDate && submitted) {
              <div class="reg-err">
                {{invalidDateText}}
              </div>
            }
            @if (futureStartDate && submitted && !invalidStartDate) {
              <div class="reg-err">
                {{pastDateText}}
              </div>
            }
            @if (startDateAfterEndDate && submitted && !invalidStartDate && !futureStartDate) {
              <div class="reg-err">
                {{startAfterEndText}}
              </div>
            }
            @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted && !invalidStartDate && !futureStartDate && !startDateAfterEndDate) {
              <div class="reg-err"
                >
                {{ppQuestion.helpText}}
              </div>
            }
          </div>
        }
        @if (ppQuestion.displayFormat.value === 'DATE_PICKER' && ppQuestion.mappingField === 'studyEndDate') {
          <div class="reg-wrap flex flex-column flex-1 mb8 relative">
            <!-- <label for="picker" class="mb4 d-inline-block">{{ppQuestion.label}}<span *ngIf="ppQuestion.mandatory === false" class="optional-text"> {{optionalText}}</span></label> -->
            <div class="relative">
              <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">
                {{ ppQuestion.label }}@if (ppQuestion.mandatory === false) {
                <span class="optional-text"> {{optionalText}}</span>
              } </label>
              <span class="tooltip inline-flex" [class.active]="showEndDateTooltip">
                <span class="cursor-pointer" (click)="toggleTooltip($event, 'endDate')">
                  <img src="./assets/icons/info-icon.svg" alt="info icon" width="20" height="20" />
                </span>
                <div class="tooltip-box absolute">
                  <span class="tooltip-close" (click)="closeTooltip($event, 'endDate')"><img src="./assets/icons/tooltip-close.svg" alt="close" width="20" height="20" /></span>
                  <p>
                    {{infoTooltipText}}
                  </p>
                  <div class="tooltip-arrow absolute"></div>
                </div>
              </span>
            </div>
            <mat-form-field [ngClass]="{'date-error':((invalidEndDate || endDateBeforeStartDate || (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required'))) && submitted)}" appearance="fill" class="custom-date-wrapper focus-none">
              <input formControlName="{{ppQuestion.mappingField}}" (dateChange)="onDateChange($event, 'studyEndDate')" (keydown.enter)="preventEnter($event)" matInput
                [matDatepicker]="picker" class="date-picker-input" aria-label="Graduation date" [placeholder]="ppQuestion.defaultValue || datePlaceholderText" />
              <span matSuffix class="date-suffix-icons">
                @if (academicDetailsForm.get(ppQuestion.mappingField)?.value) {
                  <button
                    (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear date"
                    type="button" class="date-clear-icon">
                    <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                  </button>
                }
                <mat-datepicker-toggle [for]="picker" class="custom-date"></mat-datepicker-toggle>
              </span>
              <mat-datepicker #picker panelClass="custom-datepicker">
                <mat-datepicker-actions>
                  <button mat-button matDatepickerCancel class="calendar-btn secondary-btn">{{cancelText}}</button>
                  <button mat-raised-button color="primary" matDatepickerApply
                  class="calendar-btn primary-btn">{{applyText}}</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
            @if (invalidEndDate && submitted) {
              <div class="reg-err">
                {{invalidDateText}}
              </div>
            }
            @if (endDateBeforeStartDate && submitted && !invalidEndDate) {
              <div class="reg-err">
                {{endBeforeStartText}}
              </div>
            }
            @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted && !invalidEndDate && !endDateBeforeStartDate) {
              <div class="reg-err"
                >
                {{ppQuestion.helpText}}
              </div>
            }
          </div>
        }
      <!-- </div>
    </ng-container> -->
    <!-- Course duration -->
    @if (ppQuestion.displayFormat.value === 'TEXT_BOX' && ppQuestion.mappingField === 'studyDuration') {
      <div class="reg-wrap mb8"
        >
        <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
          <span class="optional-text"> {{optionalText}}</span>
        }</label>
        <mat-form-field>
          <input
            [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'input-error w100':'w100'"
            matInput id="" aria-label="course duration" inputmode="decimal" formControlName="{{ppQuestion.mappingField}}"
            (blur)="onInputString(ppQuestion.mappingField, $event)" (keydown.enter)="preventEnter($event)">
        </mat-form-field>
        @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
          <div class="reg-err"
            >
            {{ppQuestion.helpText}}
          </div>
        }
        @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('pattern') && submitted) {
          <div class="reg-err"
            >
            {{onlyNumbersAllowedText}}
          </div>
        }
      </div>
    }
    <!-- grade type, grade -->
    <!-- <ng-container *ngIf="ppQuestion.mappingField === 'gradeType' || ppQuestion.mappingField === 'finalGrade'">
    <div
      [ngClass]="{'qual-type-field' : ppQuestion.mappingField === 'gradeType' , 'qual-title-field': ppQuestion.mappingField === 'finalGrade'}"
      class="ques-wrap dropdown-field mb8"> -->
      @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'gradeType' && showGradeType()) {
        <div class="reg-wrap flex flex-column flex-1 mb8 padding-fix trigger-width"
          >
          <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
            <span class="optional-text"> {{optionalText}}</span>
          }</label>
          <mat-form-field
            [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes relative input-error':'slct-boxes relative'">
            <mat-select formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}"
              aria-label="{{ppQuestion.label}}">
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="searchFilters[ppQuestion.mappingField]"
                  noEntriesFoundLabel="No results found">
                </ngx-mat-select-search>
              </mat-option>
              @for (optionValue of filteredOptions[ppQuestion.mappingField] | async; track optionValue) {
                <mat-option  id="{{optionValue.option_value}}" [value]="optionValue.option_label"
                  (click)="onInputChange(ppQuestion.mappingField, optionValue, $event)">
                  {{optionValue.option_label}}
                </mat-option>
              }
            </mat-select>
            @if (academicDetailsForm.get(ppQuestion.mappingField)?.value) {
              <button
                (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear selection"
                type="button" class="select-clear-icon right-52">
                <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
              </button>
            }
          </mat-form-field>
          @if (submitted && academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required')) {
            <div class="reg-err"
              >
              {{ppQuestion.helpText}}
            </div>
          }
        </div>
      }
      <!-- grade - when its a dropdown -->
      @if ((ppQuestion.mappingField === 'finalGrade' && ppQuestion.displayFormat.value === 'SELECT_BOX') && showFinalGrade() && gradeInputType === 'dropdown') {
        <div class="reg-wrap flex flex-column flex-1  mb8 padding-fix"
          >
          <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
            <span class="optional-text"> {{optionalText}}</span>
          }</label>
          <mat-form-field
            [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes relative input-error':'slct-boxes relative'">
            <mat-select formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}"
              aria-label="{{ppQuestion.label}}">
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="searchFilters[ppQuestion.mappingField]"
                  noEntriesFoundLabel="No results found">
                </ngx-mat-select-search>
              </mat-option>
              @for (optionValue of filteredOptions[ppQuestion.mappingField] | async; track optionValue) {
                <mat-option [value]="optionValue.option_label"
                  (click)="onInputChange(ppQuestion.mappingField, optionValue, $event)" id="{{optionValue.option_value}}">
                  {{optionValue.option_label}}
                </mat-option>
              }
            </mat-select>
            @if (academicDetailsForm.get(ppQuestion.mappingField)?.value) {
              <button aria-label="Clear selection" type="button"
                (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()"
                class="select-clear-icon right-52">
                <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
              </button>
            }
          </mat-form-field>
          @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
            <div class="reg-err"
              >
              {{ppQuestion.helpText}}
            </div>
          }
        </div>
      }
      <!-- grade - when its an input field for numeric values -->
      @if (ppQuestion.mappingField === 'finalGrade' && showFinalGrade() && gradeInputType === 'input') {
        <div class="reg-wrap flex flex-column flex-1">
          <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
            <span class="optional-text"> {{optionalText}}</span>
          }</label>
          <mat-form-field class="focus-none">
            <input
              [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'input-error w100':'w100'"
              matInput id="" aria-label="grade" formControlName="{{ppQuestion.mappingField}}" [placeholder]="gradeInputConfig ? gradeInputConfig.min_value + ' - ' + gradeInputConfig.max_value : ''"
              [min]="gradeInputConfig?.min_value" [max]="gradeInputConfig?.max_value" [step]="gradeInputConfig?.interval"
              type="number"
              (wheel)="$event.preventDefault()"
              (blur)="onInputString(ppQuestion.mappingField, $event)" (keydown.enter)="preventEnter($event)">
          </mat-form-field>
          @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
            <div class="reg-err"
              >
              {{ppQuestion.helpText}}
            </div>
          }
          @if (gradeInputConfig && (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('min') || academicDetailsForm.get(ppQuestion.mappingField)?.hasError('max')) && submitted) {
            <div class="reg-err"
              >
              {{validScoreBetweenText}} {{gradeInputConfig.min_value}} {{andText}} {{gradeInputConfig.max_value}}
            </div>
          }
        </div>
      }
    <!-- </div>
  </ng-container> -->
  <!-- Institution Pass Score and Honours Degree (after grade field) -->
  <!-- Institution Pass Score -->
  @if (ppQuestion.mappingField === 'applicableGrade' && showApplicableGrade() && ppQuestion.questionAttributeId === passScoreAttributeId) {
    <div class="reg-wrap flex flex-column flex-1 mt44 mt28-700 mb8 padding-fix"
      >
      <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
        <span class="optional-text"> {{optionalText}}</span>
      }</label>
      <mat-form-field
        [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes relative input-error':'slct-boxes relative'">
        <mat-select formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}" aria-label="{{ppQuestion.label}}">
          @for (optionValue of ppQuestion.options; track optionValue) {
            <mat-option [value]="optionValue.option_label"
              (click)="onInputChange(ppQuestion.mappingField, optionValue, $event)" id="{{optionValue.option_value}}">
              {{optionValue.option_label}}
            </mat-option>
          }
        </mat-select>
        @if (academicDetailsForm.get(ppQuestion.mappingField)?.value) {
          <button
            (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear selection"
            type="button" class="select-clear-icon right-52">
            <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
          </button>
        }
      </mat-form-field>
      @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
        <div class="reg-err">
          {{ppQuestion.helpText}}
        </div>
      }
    </div>
  }
  <!-- Honours Degree -->
  @if (ppQuestion.mappingField === 'isHonoursDegree' && showHonoursAndPassScore() && !isUgQualification) {
    <div class="ques-wrap mb8">
      <label class="mt44 mt28-700 mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
        <span class="optional-text"> {{optionalText}}</span>
      }</label>
      <mat-chip-listbox id="isHonoursDegree" class="tag-list" formControlName="isHonoursDegree" [attr.aria-label]="ppQuestion.label">
        @for (optionValue of ppQuestion.options; track optionValue) {
          <mat-chip-option tabindex="0" [attr.aria-label]="optionValue.option_label" class="tag"
            [value]="optionValue.option_label"
            (selectionChange)="onHonoursChipChange($event, optionValue.option_value === '1')">
            {{optionValue.option_label}}
          </mat-chip-option>
        }
      </mat-chip-listbox>
      @if (academicDetailsForm.get('isHonoursDegree')?.hasError('required') && submitted) {
        <div class="reg-err"
          >
          {{ppQuestion.helpText}}
        </div>
      }
    </div>
  }
  <!-- Number of Backlogs or Retakes (rendered after honours) -->
  @if (ppQuestion.mappingField === 'isHonoursDegree' && (showHonoursAndPassScore()) && !isUgQualification && selectedStudyCountryCode === 'IND') {
    @if (getBacklogsQuestion()) {
      <div class="reg-wrap flex flex-column flex-1 mt44 mt28-700 mb8 padding-fix">
        <label for="numberOfBacklogsOrRetakes" class="mb4 d-inline-block">{{getBacklogsQuestion()?.label}}@if (getBacklogsQuestion()?.mandatory === false) {
          <span class="optional-text"> {{optionalText}}</span>
        }</label>
        <mat-form-field class="focus-none">
          <input
            [ngClass]="(academicDetailsForm.get('numberOfBacklogsOrRetakes')?.hasError('required') || academicDetailsForm.get('numberOfBacklogsOrRetakes')?.hasError('min') || academicDetailsForm.get('numberOfBacklogsOrRetakes')?.hasError('max') || academicDetailsForm.get('numberOfBacklogsOrRetakes')?.hasError('pattern')) && submitted?'input-error w100':'w100'"
            matInput aria-label="numberOfBacklogsOrRetakes" formControlName="numberOfBacklogsOrRetakes"
            [placeholder]="getBacklogsMin(getBacklogsQuestion()) + ' - ' + getBacklogsMax(getBacklogsQuestion())"
            type="number"
            [min]="getBacklogsMin(getBacklogsQuestion())" [max]="getBacklogsMax(getBacklogsQuestion())"
            (wheel)="$event.preventDefault()"
            (blur)="onInputString('numberOfBacklogsOrRetakes', $event)" (keydown.enter)="preventEnter($event)">
        </mat-form-field>
        @if (academicDetailsForm.get('numberOfBacklogsOrRetakes')?.hasError('required') && submitted) {
          <div class="reg-err">
            {{getBacklogsQuestion()?.helpText}}
          </div>
        }
        @if ((academicDetailsForm.get('numberOfBacklogsOrRetakes')?.hasError('min') || academicDetailsForm.get('numberOfBacklogsOrRetakes')?.hasError('max')) && submitted) {
          <div class="reg-err">
            {{getBacklogsQuestion()?.helpText}}
          </div>
        }
        @if (academicDetailsForm.get('numberOfBacklogsOrRetakes')?.hasError('pattern') && submitted) {
          <div class="reg-err">
            {{getBacklogsQuestion()?.helpText}}
          </div>
        }
      </div>
    }
    @if (getBacklogsLast2YearsQuestion()) {
      <div class="reg-wrap flex flex-column flex-1 mb8 padding-fix trigger-width">
        <label for="numberOfBacklogsRetakesInLast2Years" class="mb4 d-inline-block">{{getBacklogsLast2YearsQuestion()?.label}}@if (getBacklogsLast2YearsQuestion()?.mandatory === false) {
          <span class="optional-text"> {{optionalText}}</span>
        }</label>
        <mat-form-field class="focus-none">
          <input
            [ngClass]="(academicDetailsForm.get('numberOfBacklogsRetakesInLast2Years')?.hasError('required') || academicDetailsForm.get('numberOfBacklogsRetakesInLast2Years')?.hasError('min') || academicDetailsForm.get('numberOfBacklogsRetakesInLast2Years')?.hasError('max') || academicDetailsForm.get('numberOfBacklogsRetakesInLast2Years')?.hasError('pattern')) && submitted?'input-error w100':'w100'"
            matInput aria-label="numberOfBacklogsRetakesInLast2Years" formControlName="numberOfBacklogsRetakesInLast2Years"
            [placeholder]="getBacklogsMin(getBacklogsLast2YearsQuestion()) + ' - ' + getBacklogsMax(getBacklogsLast2YearsQuestion())"
            type="number"
            [min]="getBacklogsMin(getBacklogsLast2YearsQuestion())" [max]="getBacklogsMax(getBacklogsLast2YearsQuestion())"
            (wheel)="$event.preventDefault()"
            (blur)="onInputString('numberOfBacklogsRetakesInLast2Years', $event)" (keydown.enter)="preventEnter($event)">
        </mat-form-field>
        @if (academicDetailsForm.get('numberOfBacklogsRetakesInLast2Years')?.hasError('required') && submitted) {
          <div class="reg-err">
            {{getBacklogsLast2YearsQuestion()?.helpText}}
          </div>
        }
        @if ((academicDetailsForm.get('numberOfBacklogsRetakesInLast2Years')?.hasError('min') || academicDetailsForm.get('numberOfBacklogsRetakesInLast2Years')?.hasError('max')) && submitted) {
          <div class="reg-err">
            {{getBacklogsLast2YearsQuestion()?.helpText}}
          </div>
        }
        @if (academicDetailsForm.get('numberOfBacklogsRetakesInLast2Years')?.hasError('pattern') && submitted) {
          <div class="reg-err">
            {{getBacklogsLast2YearsQuestion()?.helpText}}
          </div>
        }
      </div>
    }
  }
  <!-- language of study -->
  @if (ppQuestion.displayFormat.value === 'SELECT_BOX' &&ppQuestion.mappingField === 'studyLanguageName') {
    <div class="ques-wrap dropdown-field select-p-unset mb8"
      >
      <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
        <span class="optional-text"> {{optionalText}}</span>
      }</label>
      <mat-form-field
        [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes relative input-error':'slct-boxes relative'">
        <mat-select formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}" #select aria-label="{{ppQuestion.label}}">
          <mat-option>
            <ngx-mat-select-search
              [formControl]="searchFilters[ppQuestion.mappingField]"
              noEntriesFoundLabel="No results found">
            </ngx-mat-select-search>
          </mat-option>
          @for (optionValue of filteredOptions[ppQuestion.mappingField] | async; track optionValue) {
            <mat-option
              (click)="onInputChange(ppQuestion.mappingField, optionValue, $event)" [value]="optionValue.option_label" id="{{optionValue.option_value}}">
              {{optionValue.option_label}}
            </mat-option>
          }
        </mat-select>
        @if (academicDetailsForm.get(ppQuestion.mappingField)?.value) {
          <button
            (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear selection"
            type="button" class="select-clear-icon right-52">
            <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
          </button>
        }
      </mat-form-field>
      @if (submitted && academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required')) {
        <div
          class="reg-err">
          {{ppQuestion.helpText}}
        </div>
      }
    </div>
  }
  <!-- Study Status -->
  <!-- <div class="ques-wrap mb8" *ngIf="ppQuestion.mappingField === 'studyStatus' || ppQuestion.mappingField === 'studyMode'">
  <label class="ques-hd d-inline-block">{{ppQuestion.label}}</label>
  <mat-chip-listbox class="tag-list" formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}"[attr.aria-label]="ppQuestion.label">
    <mat-chip-option tabindex="0" [aria-label]="ppQuestion.options.option_label" class="tag" *ngFor="let optionValue of ppQuestion.options" id="{{optionValue.option_value}}"
      [value]="optionValue.option_label"
      (selectionChange)="onInputChange(ppQuestion.mappingField, optionValue, $event)">
      {{optionValue.option_label}}
    </mat-chip-option>
  </mat-chip-listbox>
  <div class="reg-err" *ngIf="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted">
    {{ppQuestion.helpText}}
  </div>
</div> -->
<!-- grade type -->
<!-- <div class="ques-wrap dropdown-field select-p-unset mb8" *ngIf="ppQuestion.mappingField === 'isHonoursDegree'">
<label class="mb4 d-inline-block">{{ppQuestion.label}}</label>
<mat-form-field [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes relative input-error':'slct-boxes relative'">
  <mat-select formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}" aria-label="{{ppQuestion.label}}">
    <mat-option *ngFor="let optionValue of ppQuestion.options" [value]="optionValue.option_label" (click)="onInputChange(ppQuestion.mappingField, optionValue, $event)" id="{{optionValue.option_value}}">
      {{optionValue.option_label}}
    </mat-option>
  </mat-select>
  <button *ngIf="academicDetailsForm.get(ppQuestion.mappingField)?.value" (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear selection" type="button" class="select-clear-icon">
    <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
  </button>
</mat-form-field>
<div class="reg-err" *ngIf="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted">
  {{ppQuestion.helpText}}
</div>
</div> -->
<!-- grade -->
<!-- <div class="reg-wrap mb8" *ngIf="ppQuestion.mappingField === 'qualificationTitle'">
<label for="" class="mb4 d-inline-block">{{ppQuestion.label}}</label>
<mat-form-field>
  <input
    [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'input-error w100':'w100'"
    matInput id="" aria-label="first name" formControlName="{{ppQuestion.mappingField}}"
    (blur)="onInputString(ppQuestion.mappingField, $event)" (keydown.enter)="preventEnter($event)">
</mat-form-field>
<div class="reg-err" *ngIf="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted">
  {{ppQuestion.helpText}}
</div>
</div> -->
<!-- test name, test date -->
<!-- <ng-container *ngIf="(ppQuestion.mappingField === 'testType' && ppQuestion.questionAttributeId === 2326) || (ppQuestion.mappingField === 'testTakenDate' && ppQuestion.questionAttributeId === 2337)">
<div
  [ngClass]="{'qual-type-field' : ppQuestion.mappingField === 'testType' , 'qual-title-field': ppQuestion.mappingField === 'testTakenDate'}"
  class="ques-wrap dropdown-field mb8"> -->
  @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'testType' && ppQuestion.questionAttributeId === 2326) {
    <p class="mt44 mb8 qr-help-text font-bold">{{academicTestText}}</p>
    <div class="reg-wrap flex flex-column flex-1 mb8 padding-fix"
      >
      <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false && !admissionTestFieldsRequired) {
        <span class="optional-text"> {{optionalText}}</span>
      }</label>
      <mat-form-field
        [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes relative input-error':'slct-boxes relative'">
        <mat-select formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}"
          aria-label="{{ppQuestion.label}}">
          @for (optionValue of ppQuestion.options; track optionValue) {
            <mat-option [value]="optionValue.option_label"
              (click)="onInputChange(ppQuestion.mappingField, optionValue, $event)" id="{{optionValue.option_value}}">
              {{optionValue.option_label}}
            </mat-option>
          }
        </mat-select>
        @if (academicDetailsForm.get(ppQuestion.mappingField)?.value) {
          <button
            (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear selection"
            type="button" class="select-clear-icon right-52">
            <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
          </button>
        }
      </mat-form-field>
      @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
        <div class="reg-err"
          >
          {{ppQuestion.helpText}}
        </div>
      }
    </div>
  }
  @if ((academicDetailsForm.get('testType')?.value && !isAcademicTestNotTaken()) && ppQuestion.displayFormat.value === 'DATE_PICKER' && ppQuestion.mappingField === 'testTakenDate' && ppQuestion.questionAttributeId === 2337) {
    <div class="reg-wrap flex flex-column flex-1 mb8 relative">
      <!-- <label for="picker" class="mb4 d-inline-block">{{ppQuestion.label}}<span *ngIf="ppQuestion.mandatory === false" class="optional-text"> {{optionalText}}</span></label> -->
      <div class="relative">
        <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">
          {{ ppQuestion.label }} </label>
        <span class="tooltip inline-flex" [class.active]="showTestDateTooltip">
          <span class="cursor-pointer" (click)="toggleTooltip($event, 'testDate')">
            <img src="./assets/icons/info-icon.svg" alt="info icon" width="20" height="20" />
          </span>
          <div class="tooltip-box absolute">
            <span class="tooltip-close" (click)="closeTooltip($event, 'testDate')"><img src="./assets/icons/tooltip-close.svg" alt="close" width="20" height="20" /></span>
            <p class="para-sty">
              {{infoTooltipText}}
            </p>
            <div class="tooltip-arrow absolute"></div>
          </div>
        </span>
      </div>
      <mat-form-field [ngClass]="{'date-error':((invalidTestDate || futureTestDate || (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required'))) && submitted)}" appearance="fill" class="custom-date-wrapper focus-none">
        <input formControlName="{{ppQuestion.mappingField}}" [max]="todayDate" (dateChange)="onDateChange($event, 'testTakenDate')" (keydown.enter)="preventEnter($event)" matInput
          [matDatepicker]="picker" class="date-picker-input" aria-label="Test taken date" [placeholder]="ppQuestion.defaultValue || datePlaceholderText" />
        <span matSuffix class="date-suffix-icons">
          @if (academicDetailsForm.get(ppQuestion.mappingField)?.value) {
            <button
              (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear date"
              type="button" class="date-clear-icon">
              <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
            </button>
          }
          <mat-datepicker-toggle [for]="picker" class="custom-date"></mat-datepicker-toggle>
        </span>
        <mat-datepicker #picker panelClass="custom-datepicker">
          <mat-datepicker-actions>
            <button mat-button matDatepickerCancel class="calendar-btn secondary-btn">{{cancelText}}</button>
            <button mat-raised-button color="primary" matDatepickerApply
            class="calendar-btn primary-btn">{{applyText}}</button>
          </mat-datepicker-actions>
        </mat-datepicker>
      </mat-form-field>
      @if (invalidTestDate && submitted) {
        <div class="reg-err">
          {{invalidDateText}}
        </div>
      }
      @if (futureTestDate && submitted && !invalidTestDate) {
        <div class="reg-err">
          {{pastDateText}}
        </div>
      }
      @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted && !invalidTestDate && !futureTestDate) {
        <div class="reg-err"
          >
          {{ppQuestion.helpText}}
        </div>
      }
    </div>
  }
<!-- </div>
</ng-container> -->
<!-- overall score - for conditional json -->
@if (ppQuestion.displayFormat.value === 'RANGE' && ppQuestion.mappingField === 'overallScore' && ppQuestion.questionAttributeId === 2336 && (academicDetailsForm.get('testType')?.value && !isAcademicTestNotTaken())) {
  <div class="reg-wrap mb8">
    <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}</label>
    <mat-form-field>
      <input
        [ngClass]="academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'input-error w100':'w100'"
        matInput [id]="ppQuestion.mappingField" aria-label="overall score" type="number" formControlName="{{ppQuestion.mappingField}}"
        [placeholder]="testScoreConfig ? (testScoreConfig.max ? testScoreConfig.min + ' - ' + testScoreConfig.max : testScoreConfig.min + '+') : ''"
        (wheel)="$event.preventDefault()"
        (blur)="onInputString(ppQuestion.mappingField, $event)" (keydown.enter)="preventEnter($event)">
    </mat-form-field>
    @if (academicDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
      <div class="reg-err"
        >
        {{ppQuestion.helpText}}
      </div>
    }
    @if ((academicDetailsForm.get(ppQuestion.mappingField)?.hasError('min') || academicDetailsForm.get(ppQuestion.mappingField)?.hasError('max')) && submitted) {
      <div class="reg-err"
        >
        {{validScoreBetweenText}} {{testScoreConfig?.min}} {{testScoreConfig?.max ? andText + ' ' + testScoreConfig.max : ''}}
      </div>
    }
  </div>
}
}
<div class="primary-btn-cnr flex gap12 mt44 mt28-700">
  <button class="secondary-btn" (click)="backButton ()">{{backText}}</button>
  <button class="primary-btn" (click)="nextButton()">{{nextText}}</button>
</div>
</form>
</div>
}

<button class="scroll-top-btn flex items-center justify-center" [class.visible]="showScrollBtnAcademic" [class.scrolling]="isScrollingAcademic" [disabled]="isScrollingAcademic" (click)="scrollToTop()" aria-label="Scroll to top">
  <img src="./assets/icons/arrow-up-icon.svg" alt="Go to top arrow icon" width="24" height="24" />
</button>
